import React, { useState } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import UserProfile from '../../Component/Normal/UserProfile';

import DefaultLogoPath from '../../image/DefaultLogo.svg';
import { ReactComponent as DeleteIcon } from '../../image/Delete.svg';

export default function ProgramFollowTile(props) {
  const { data, onClickTile, onClickDelete } = props;

  const { t } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isTrashHovered, setIsTrashHovered] = useState(false);

  const isPending = data.status === false;

  // 휴지통 클릭시 (타일 클릭 버블링 차단) //
  function onClickTrashButton(e) {
    e.stopPropagation();
    onClickDelete(data);
  }

  return (
    <TileWrapper>
      <LogoBox>
        <UserProfile profile={data.storeLogo} defaultProfile={DefaultLogoPath} />
      </LogoBox>
      <TrashButton
        isHovered={isTrashHovered}
        defaultBg={theme.whiteAlpha20}
        hoverBg={theme.pointRedAlpha20}
        onClick={onClickTrashButton}
        onMouseEnter={() => setIsTrashHovered(true)}
        onMouseLeave={() => setIsTrashHovered(false)}>
        <TrashIcon />
      </TrashButton>
      {
        isPending &&
        <PendingBadge backgroundColor={theme.primaryAlpha20} borderColor={theme.primaryAlpha50}>
          <BadgeText color={theme.text}>{t('myStoreSetting.program.pending')}</BadgeText>
        </PendingBadge>
      }
    </TileWrapper>
  );
}

const TileWrapper = styled.div`
  position: relative;
  display: flex;

  flex-shrink: 0;

  width: 100px;
  height: 100px;

  border-radius: 5px;

  overflow: hidden;

`;

const LogoBox = styled.div`
  width: 100%;
  height: 100%;
`;

const TrashButton = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 30px;
  height: 30px;

  border-bottom-left-radius: 5px;
  border-top-right-radius: 5px;

  background-color: ${props => props.isHovered ? props.hoverBg : props.defaultBg};

  transition: all 0.2s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TrashIcon = styled(DeleteIcon)`
  width: 20px;
  height: 20px;

  color: #FFFFFF;
`;

const PendingBadge = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;

  display: flex;

  justify-content: center;
  align-items: center;

  padding: 3px 10px;

  border: 1px solid ${props => props.borderColor};
  border-radius: 2px;
  background-color: ${props => props.backgroundColor};
`;

const BadgeText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 11px;
  line-height: 12px;

  margin: 0;

  color: ${props => props.color};
`;
